import Swal from 'sweetalert2';

type AlertIcon = 'success' | 'error' | 'warning' | 'info' | 'question';

interface AlertOptions {
	title: string;
	text: string;
	icon: AlertIcon;
	input?: 'text' | 'textarea' | 'email' | 'number' | 'password' | 'url' | 'select';
	inputPlaceholder?: string;
	inputValidator?: (value: string) => string | null | Promise<string | null>;
	confirmButtonText?: string;
	showCancelButton?: boolean;
	confirmButtonColor?: string;
	cancelButtonColor?: string;
}

const showAlert = ({
	title,
	text,
	icon,
	confirmButtonText = 'OKAY',
	showCancelButton = false,
	confirmButtonColor = '#3085d6',
	cancelButtonColor = '#d33',
	input,
	inputPlaceholder,
	inputValidator,
}: AlertOptions) => {
	return Swal.fire({
		title,
		text,
		icon,
		confirmButtonText,
		showCancelButton,
		confirmButtonColor,
		cancelButtonColor,
		input,
		inputPlaceholder,
		inputValidator,
	});
};

export default showAlert;
